import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var getCourseTimerRes;
export const getCourseTimerTodo = createAsyncThunk('getCourseTimer', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/get_course_timer',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_id": val,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return getCourseTimerRes = res.data
    } catch (error) {
        return getCourseTimerRes = error.response.data
    }
})


const getCourseTimerSlice = createSlice({
    name: 'getCourseTimer',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(getCourseTimerTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('getCourseTimer', state.data)
            }
        });
        builder.addCase(getCourseTimerTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default getCourseTimerSlice.reducer; 